---
meta:
  - title: Buscador Legal - IUSPRO Docs
  - description: Aprende a usar el Buscador Legal para encontrar normativa, jurisprudencia y documentos oficiales.
---

# Buscador Legal

El Buscador Legal le permite buscar simultáneamente en varias bases de datos legales de Costa Rica desde un solo lugar.

## Bases de datos disponibles

Al realizar una búsqueda, puede seleccionar una o varias de estas fuentes:

- **Normativa** — Leyes, decretos, reglamentos y legislación vigente de Costa Rica
- **Resoluciones Judiciales** — Sentencias y resoluciones del Poder Judicial
- **Contraloría General** — Documentos y dictámenes de la CGR
- **Tribunal Registral Administrativo** — Votos del TRA

## ¿Cómo funciona?

### Paso 1: Escriba su consulta

Ingrese su búsqueda en el campo de texto. Puede usar términos legales, nombres de leyes o describir el tema que necesita investigar.

Ejemplos de búsquedas:

- "divorcio por mutuo consentimiento"
- "prescripción laboral"
- "responsabilidad civil extracontractual"

### Paso 2: Seleccione las bases de datos

Debajo del campo de búsqueda verá las fuentes disponibles. Active o desactive cada base de datos según lo que necesite. Debe tener al menos una seleccionada.

### Paso 3: Revise los resultados

Los resultados se muestran ordenados por relevancia. Para cada resultado verá:

- **Tipo de documento** — Identificado por color según la fuente
- **Título del documento**
- **Año de publicación**
- **Extracto del contenido** — Un resumen de la parte más relevante
- **Porcentaje de relevancia** — Qué tan relacionado está con su búsqueda

## Filtrar y ordenar resultados

En la parte superior de los resultados puede:

- **Filtrar por tipo**: Ver solo leyes, resoluciones, documentos de la CGR o votos del TRA
- **Ordenar por relevancia o por fecha**: Para resoluciones, documentos de la CGR y votos del TRA puede cambiar entre orden por relevancia o por fecha más reciente

## Acciones sobre los resultados

- **Ver el documento original**: Haga clic en cualquier resultado para abrir el documento completo en su fuente original
- **Ocultar un resultado**: Haga clic en la X para quitar un resultado que no le interese
- **Resumir con Auri**: En las resoluciones judiciales puede hacer clic en "Resumir con Auri" para que el asistente le genere un resumen

## Cargar más resultados

Si necesita más resultados, al final de la lista encontrará el botón **Cargar más resultados**. Esto traerá documentos adicionales sin duplicar los que ya tiene.

## Historial de búsquedas

Todas sus búsquedas se guardan automáticamente. En la pantalla principal del Buscador verá sus búsquedas recientes y puede volver a cualquiera de ellas haciendo clic.

También puede escribir en el campo de búsqueda para filtrar su historial y acceder rápidamente a una búsqueda anterior.

## Repetir una búsqueda

Si una búsqueda tiene más de un día de antigüedad, el sistema le sugerirá repetirla para obtener resultados actualizados. También puede repetir cualquier búsqueda manualmente con el botón de actualizar junto al título.
